export default {
    pia_00001:'财务中心'
}